import { useResolution } from '@lingoda/ui';
import { DesktopPackageItem, MobilePackageItem, TabletPackageItem } from '../../components';
import DesktopLayout from './PackageLayout/Desktop';
import TabletLayout from './PackageLayout/Tablet';
import MobileLayout from './PackageLayout/Mobile';

function useResponsivePackageLayout() {
    const isMobile = useResolution('phone');
    const isPhablet = useResolution('phablet');

    if (isMobile) {
        return { Layout: MobileLayout, Item: MobilePackageItem };
    } else if (isPhablet) {
        return { Layout: TabletLayout, Item: TabletPackageItem };
    }

    return { Layout: DesktopLayout, Item: DesktopPackageItem };
}

export default useResponsivePackageLayout;
